import rideTypeService from '@/http/services/ridetype'
import store from '../../../store'
export default {
  getRideTypes ({ commit }) {
    return rideTypeService.getRideTypes(store.state.apiUrl).then((response) => {
      console.log('Ride types', response)
      commit('setRideTypes', response.data)
    })
  }
}
